import React, { useState } from 'react';
import { CourseIcon, COURSE_VARIANT_BY_ID } from './CourseOfferCard';
import CoursePurchaseSection from './CoursePurchaseSection';
import { userOwnsDigitalCourse } from '../utils/personalAreaCourses';

export default function CourseLandingPage({ selectedCourse, onBack, personalAreaUser }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    organization: '',
    message: '',
  });

  const handleFormInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('תודה על הפנייה! נחזור אליכם בהקדם.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      organization: '',
      message: '',
    });
  };

  if (!selectedCourse) {
    return <div className="gl-course-landing gl-course-landing--loading">טוען…</div>;
  }

  const ownsCourse = userOwnsDigitalCourse(selectedCourse, personalAreaUser?.purchasedCourses);
  const showPurchaseFlow = Boolean(personalAreaUser?.id && !ownsCourse);
  const variant = COURSE_VARIANT_BY_ID[selectedCourse.id] || 'default';
  const price = selectedCourse.price || selectedCourse.details?.price || '';
  const courseNum = selectedCourse.courseNumber
    ? String(selectedCourse.courseNumber).padStart(2, '0')
    : null;

  return (
    <div className="gl-course-landing">
      <div className="gl-course-landing__orb gl-course-landing__orb--gold" aria-hidden="true" />
      <div className="gl-course-landing__orb gl-course-landing__orb--blue" aria-hidden="true" />

      <header className="gl-course-landing__nav">
        <div className="gl-course-landing__nav-inner">
          <button type="button" className="gl-brand" onClick={onBack}>
            <img src="/phone/gl-logo.png" alt="" className="gl-brand-mark" />
            <span>Great Leaders</span>
          </button>
          <button type="button" className="gl-courses-back gl-course-landing__back" onClick={onBack}>
            חזרה
          </button>
        </div>
      </header>

      <main className="gl-course-landing__main">
        <section className="gl-course-landing__hero" aria-labelledby="course-landing-title">
          <div className={`gl-course-landing__visual gl-course-landing__visual--${variant}`}>
            <div className="gl-course-landing__visual-glow" aria-hidden="true" />
            {courseNum ? <span className="gl-course-landing__num">{courseNum}</span> : null}
            <span className="gl-course-landing__icon">
              <CourseIcon variant={variant} />
            </span>
          </div>

          <div className="gl-course-landing__copy">
            <p className="gl-kicker">
              {ownsCourse && personalAreaUser?.id ? 'בבעלותכם · מסלול דיגיטלי' : 'מסלול דיגיטלי'}
            </p>
            <h1 id="course-landing-title">{selectedCourse.title}</h1>
            <p className="gl-courses-page-lead gl-course-landing__lead">
              {selectedCourse.description || selectedCourse.summary}
            </p>

            {price ? (
              <p className="gl-offer-card-price" aria-label={`מחיר: ${price}`}>
                <span className="gl-offer-card-price-chip gl-course-landing__price">
                  <span className="gl-offer-card-price-label">מחיר</span>
                  <span className="gl-offer-card-price-value">{price}</span>
                </span>
              </p>
            ) : null}

            {ownsCourse && personalAreaUser?.id ? (
              <button
                type="button"
                className="gl-academy-hero-cta gl-academy-hero-cta--primary gl-course-landing__cta"
                onClick={onBack}
              >
                חזרה לאיזור האישי
                <span aria-hidden="true">←</span>
              </button>
            ) : null}
          </div>
        </section>

        <div className="gl-course-landing__panels">
          {selectedCourse.includes?.length > 0 ? (
            <section className="gl-course-landing__panel" aria-labelledby="course-includes-title">
              <p className="gl-kicker">מה מחכה לכם</p>
              <h2 id="course-includes-title">מה יהיה במסלול</h2>
              <ul className="gl-course-landing__includes">
                {selectedCourse.includes.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </section>
          ) : null}
        </div>

        {showPurchaseFlow ? (
          <CoursePurchaseSection
            id="course-purchase"
            course={selectedCourse}
            user={personalAreaUser}
          />
        ) : null}

        {!showPurchaseFlow && !(ownsCourse && personalAreaUser?.id) ? (
          <section className="gl-course-landing__contact" aria-labelledby="course-contact-title">
            <p className="gl-kicker">יצירת קשר</p>
            <h2 id="course-contact-title">השאירו פרטים ונחזור אליכם</h2>
            <form className="gl-course-landing__contact-form" onSubmit={handleSubmit}>
              <div className="gl-course-landing__field">
                <input
                  type="text"
                  name="name"
                  placeholder="שם מלא"
                  value={formData.name}
                  onChange={handleFormInputChange}
                  required
                />
              </div>
              <div className="gl-course-landing__field">
                <input
                  type="email"
                  name="email"
                  placeholder="כתובת אימייל"
                  value={formData.email}
                  onChange={handleFormInputChange}
                  required
                />
              </div>
              <div className="gl-course-landing__field">
                <input
                  type="tel"
                  name="phone"
                  placeholder="מספר טלפון"
                  value={formData.phone}
                  onChange={handleFormInputChange}
                />
              </div>
              <div className="gl-course-landing__field">
                <input
                  type="text"
                  name="organization"
                  placeholder="שם הארגון / המוסד"
                  value={formData.organization}
                  onChange={handleFormInputChange}
                />
              </div>
              <div className="gl-course-landing__field">
                <textarea
                  name="message"
                  placeholder="הודעה (אופציונלי)"
                  value={formData.message}
                  onChange={handleFormInputChange}
                  rows="4"
                />
              </div>
              <button type="submit" className="gl-academy-hero-cta gl-academy-hero-cta--primary">
                שליחת פנייה
              </button>
            </form>
          </section>
        ) : null}
      </main>
    </div>
  );
}
